import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { decorators, Paginator } from "@orange-marmalade/paginate-this";
import { NoteTooltip } from "MODULES/shared/components/NoteTooltip";
import {
  DataTable,
  PartNumber,
  IconReceived,
  SearchFilter
} from "MODULES/shared/components";
import { AsIsFlag } from "MODULES/IncomingQuotes/shared/AsIsFlag";
import { alphaMonthYear } from "LIB/formatters/date";
import { isEmpty } from "lodash";
import { LEAD_TIME_LABEL } from "MODULES/inventories/constants";
import { translateProps } from "MODULES/shared/decorators";
import { CONDITION_TYPES } from "MODULES/Receiving/constants";

const paginatorList = "consignments/lineItems";
const ReceivedIcon = ({ quantity_received: quantityReceived, quantity }) => {
  if (quantityReceived === quantity) {
    return <IconReceived />;
  }
  return null;
};

ReceivedIcon.propTypes = {
  quantity_received: PropTypes.number,
  quantity: PropTypes.number
};

class LineItemsTable extends Component {
  static propTypes = {
    results: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
    isLoading: PropTypes.bool.isRequired
  };

  state = {
    addPartModalOpen: false,
    editPartModalOpen: false,
    searchValue: ""
  };

  openEditPartModal = lineItem =>
    this.setState({
      editPartModalOpen: true,
      selectedLineItem: lineItem
    });

  closeEditPartModal = () => this.setState({ editPartModalOpen: false });

  handleSearchValueChange = value => {
    this.setState({ searchValue: value });
  };

  renderRow = (r, idx) => (
    <tr
      key={r.id}
      className={classNames("clickable", { "text-muted": r.cancelled })}
      onClick={() => !r.cancelled && this.openEditPartModal(r)}
    >
      <td>
        <div style={{ whiteSpace: "nowrap" }}>
          <div style={{ textAlign: "right" }}>{idx + 1}</div>
        </div>
      </td>
      <td>
        <PartNumber part={r.part} />
      </td>
      <td>
        {!r.uuid || (!r.serial_number && !isEmpty(r.expected_serial_number)) ? (
          r.serial_number || r.expected_serial_number
        ) : (
          <Link to={`/inventories/${r.uuid}`}>{r.serial_number}</Link>
        )}
      </td>
      <td>
        {r.alternate &&
          (r.alternate.alternate_part_id ? (
            <PartNumber
              part={{
                id: r.alternate.alternate_part_id,
                part_number: r.alternate.name
              }}
            />
          ) : (
            r.alternate.name
          ))}
      </td>

      <td>{r.traced_to}</td>
      <td>{alphaMonthYear(r.tag_date)}</td>
      <td>{r.tagged_by}</td>
      <td className="text-center">{r.lead_time}</td>
      <td>
        {CONDITION_TYPES[r.condition].label}
        <AsIsFlag lineItem={r} className="m-l-5" />
      </td>
      <td className="text-right">{r.quantity}</td>
      <td className="text-center td-shrink-icon">
        {(r.internal_note || r.external_note) && (
          <NoteTooltip
            note={[r.internal_note, r.external_note]
              .filter(n => n !== null && n !== "")
              .join(" | ")}
            className={classNames({ "link-muted": r.cancelled })}
          />
        )}
      </td>
    </tr>
  );

  render() {
    const { results, isLoading, search } = this.props;
    const { searchValue } = this.state;

    const display =
      results.length >= 15 || searchValue ? "inline-block" : "none";

    return (
      <div>
        <h2 style={{ marginTop: 26 }}>Parts</h2>
        <div style={{ paddingBottom: "10px", display, width: "100%" }}>
          <SearchFilter
            onSubmit={search}
            onValueChange={this.handleSearchValueChange}
            placeholder="Search by Part Number"
          />
        </div>
        <DataTable.Mini loading={isLoading} numbered noMargin>
          <DataTable.Head>
            <th />
            <th>Part #</th>
            <th>Serial #</th>
            <th>Buy As Alt</th>
            <th>Trace To</th>
            <th>Tag Date</th>
            <th>Tagged By</th>
            <th>{LEAD_TIME_LABEL}</th>
            <th>Condition</th>
            <th className="text-right">Qty</th>
            <th className="text-center" />
            <th className="text-center" />
          </DataTable.Head>
          <DataTable.Body>{results.map(this.renderRow)}</DataTable.Body>
        </DataTable.Mini>
        <nav
          className="text-center margin-top-none"
          aria-label="Search results pages"
        >
          <Paginator listId={paginatorList} />
        </nav>
      </div>
    );
  }
}

const withListId = translateProps(() => ({
  listId: "consignments/lineItems"
}));

export default withListId(decorators.tabulate(LineItemsTable));



// WEBPACK FOOTER //
// ./app/modules/Consignments/Detail/LineItemsTable.jsx